import { useCallbackRef } from '../../../internal/hooks/useCallbackRef';

/**
 * Предотвращает действие для событий в примитивах radix, на основе которых сделан компонент модального окна
 * работает по принципу event.preventDefault(), т.е. если событие предотвращено, то действие не будет выполнено
 * например, если в качестве обработчика события клика "вне модалки" используется useCallbackPrevention, то при клике вне модалки
 * модалка не закроется
 * @param prevent - флаг прерывания обработчика
 * @example
 * const preventClickOutside = useCallbackPrevention(props.preventOutside);
 * const handleClickOutside = useMemo(() => composeEventHandlers(preventClickOutside, props.onClickOutside), [props.onClickOutside, preventClickOutside]);
 * return (
 *  <ModalContent onPointerOutside={handleClickOutside}>
 */
export function useCallbackPrevention() {
  var prevent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return useCallbackRef(function (event) {
    if (prevent) {
      event.preventDefault();
    }
  });
}